<script lang="ts">
	import phonezms from "@core/assets/icons/phonezms.svg?raw";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./CallUsBanner.translations.json" with { type: "json" };
	import Icon from "./common/Icon.svelte";
	import Link from "./common/Link.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";
	import { phoneNumber } from "./phoneNumber.js";

	const translate = getTranslate(translations);
</script>

<Link
	href="tel:{phoneNumber.replace(/\s+/gu, '')}"
	variant={ButtonVariant.Transparent}
	class="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 hover:bottom-5 hover:scale-95 duration-300 transition-all border border-[#9999FF] bg-[#000033] text-white md:px-8 py-2 md:py-4 px-5 rounded-[2.5rem] drop-shadow-xl flex gap-4 md:gap-6 items-center"
>
	<Icon icon={phonezms} class="md:h-10 text-[#9999FF] md:w-10 h-4 w-4" />
	<span
		class="font-medium md:text-[1.5rem]/[1.2] hidden lg:inline-block -mb-1 text-nowrap -tracking-[0.04%] text-[#9999FF]"
		>{translate("callUs")}</span
	>
	<span class="font-medium text-[1.1rem]/[1.1] md:text-[1.5rem]/[1.1] -mb-1 text-nowrap -tracking-[0.04%]"
		>{phoneNumber}</span
	>
	<span class="md:text-xs/[1.1] text-[.625rem]/[1.1] text-nowrap -tracking-[0.04em]"
		>{translate("mon-fri")}<br />8.00–15.00</span
	>
</Link>
